import React, { useState, useEffect } from 'react';
import classnames from 'classnames';

import './styles.scss';

export const SubscriptionCard = ({data, callback, activeSubscription}) => {
  const [buttonActive, setButtonActive] = useState(activeSubscription[data.key]);

  const handlerClick = (event) => {
    callback(event.target.dataset.key);
  };

  useEffect(() => {
    setButtonActive(activeSubscription[data.key]);
  },[data,activeSubscription]);

  return (
    <div className="subscription__card">
      <div className="subscription__card-header">
        {data.title && data.title}
      </div>
      <div className="subscription__card-content">
        {
          data.price && <p className="subscription__card-price">{`$${data.price}/mo.`}</p>
        }
        {
          data.price && <p className="subscription__card-text">(No contract, cancel at any time)</p>
        }
        <ul className="subscription__card-list">
          {
            data.description && data.description.map((cardListItem,i) => {
              return (
                <li 
                  key={`${i}${cardListItem}`}
                  className="subscription__card-item"
                >
                  <span className="subscription__card-icon"></span>
                  {cardListItem}
                </li>
              )
            })
          }
        </ul>
        <div className="subscription__card-btn-wrapper">
          <button 
            onClick={handlerClick} 
            data-key={data.key}
            className={classnames("subscription__card-btn", {
              "subscription__card-btn--active": buttonActive
            })}
          >
            Choose Plan
          </button>
        </div>
      </div>
    </div>
  )
};

export default SubscriptionCard;
